import { useTranslation } from 'react-i18next';
import { type AssignedCustomField } from 'services/custom-fields/schemas';
import { useAppDispatch, useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { selectContentId } from 'components/editor/grid/reduxStore/documentSettingsSlice';
import { useUpdateCustomFieldValueMutation } from '../useUpdateCustomFieldValueMutation';
import { getFieldTypeOption } from 'components/custom-fields/fieldTypeOptions';
import { CustomFieldDateInput } from './CustomFieldDateInput';
import { EditableTextCustomFieldInput } from './EditableTextCustomFieldInput';
import { CustomFieldsAutoComplete } from './CustomFieldsAutoComplete';
import { selectVariablesByName } from 'components/editor/grid/reduxStore/allVariableSlice';

type EditableCustomFieldInputProps = {
  field: AssignedCustomField;
};

export function EditableCustomFieldInput({ field }: EditableCustomFieldInputProps) {
  const { t } = useTranslation();
  const contentId = useAppSelector(selectContentId);
  const { mutate } = useUpdateCustomFieldValueMutation(contentId);

  const dispatch = useAppDispatch();

  const variableByUniqueName = useAppSelector(selectVariablesByName);
  const fieldTypeOption = getFieldTypeOption(field.type);
  const currentValue = variableByUniqueName[field.name]?.value ?? null;

  const sharedProps = { field, mutate, dispatch, currentValue, fieldTypeOption, t };

  const editableInputFieldBasedOnType: (field: AssignedCustomField) => JSX.Element = (field: AssignedCustomField): JSX.Element => {
    switch (field.type) {
      case 'date':
        return <CustomFieldDateInput {...sharedProps} />;
      case 'dropdown':
        return <CustomFieldsAutoComplete {...sharedProps} />;
      default:
        return <EditableTextCustomFieldInput {...sharedProps} />;
    }
  };

  return editableInputFieldBasedOnType(field);
}
